import { createAction, props } from '@ngrx/store';

import {
  InstitutionServicesSummary,
  ServiceSubmissionStatusFilterInputObject
} from './institution-services-summary.model';

export const getInstitutionsServicesSummary = createAction(
  '[InstitutionServicesSummary/API] Get InstitutionsServicesSummary',
  props<{
    filtering: ServiceSubmissionStatusFilterInputObject,
    isStats?: boolean
  }>()
);

export const getInstitutionServicesSummary = createAction(
  '[InstitutionServicesSummary/API] Get InstitutionServicesSummary',
  props<{ institutionServicesSummary: InstitutionServicesSummary }>()
);

export const loadInstitutionsServicesSummary = createAction(
  '[InstitutionServicesSummary/API] Load InstitutionsServicesSummary',
  props<{ institutionServicesSummarys: InstitutionServicesSummary[] }>()
);

export const upsertInstitutionServicesSummary = createAction(
  '[InstitutionServicesSummary/API] Upsert InstitutionServicesSummary',
  props<{
    institutionServicesSummary: InstitutionServicesSummary;
  }>()
);

export const upsertInstitutionsServicesSummary = createAction(
  '[InstitutionServicesSummary/API] Upsert InstitutionServicesSummarys',
  props<{
    institutionsServicesSummary: InstitutionServicesSummary[];
    sumTotalServices: number;
    sumApprServices: number;
    sumDraftServices: number;
    sumRejectedServices: number;
    totalInst: number;
  }>()
);

export const clearInstitutionsServicesSummary = createAction(
  '[InstitutionServicesSummary/API] Clear InstitutionsServicesSummary'
);
